import { AxiosResponse } from "axios";
import axiosClient from "@/services/api/index";
import { CreateInteractiveMasterplanInterface } from "@/types/InteractiveMasterplanInterface";

export default {
  getMasterplans(params = {}): Promise<AxiosResponse> {
    return axiosClient.get("interactive-masterplan", { params });
  },

  getMasterplan(id: string): Promise<AxiosResponse> {
    return axiosClient.get(`interactive-masterplan/${id}`);
  },

  getMasterplanByEstateId(estateId: string): Promise<AxiosResponse> {
    return axiosClient.get(`interactive-masterplan/estate/${estateId}`);
  },

  getHouseDesignsWithLots(estateId: string): Promise<AxiosResponse> {
    return axiosClient.get(
      `interactive-masterplan/estate/${estateId}/house-designs`
    );
  },

  createMasterplan(
    data: CreateInteractiveMasterplanInterface
  ): Promise<AxiosResponse> {
    return axiosClient.post("interactive-masterplan", data);
  },

  updateMasterplan(
    id: string,
    data: Partial<CreateInteractiveMasterplanInterface>
  ): Promise<AxiosResponse> {
    return axiosClient.patch(`interactive-masterplan/${id}`, data);
  },

  deleteMasterplan(id: string): Promise<AxiosResponse> {
    return axiosClient.delete(`interactive-masterplan/${id}`);
  },

  uploadSvgFile(data: FormData): Promise<AxiosResponse> {
    return axiosClient.post("interactive-masterplan/upload", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  deleteSvgFile(data: {
    fileName: string;
    userId: string;
    estateId: string;
  }): Promise<AxiosResponse> {
    return axiosClient.delete("interactive-masterplan/file", { data });
  },

  parseSvg(data: FormData): Promise<AxiosResponse> {
    return axiosClient.post("interactive-masterplan/parse-svg", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  uploadPoiImage(data: FormData): Promise<AxiosResponse> {
    return axiosClient.post("interactive-masterplan/poi/upload-image", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  uploadEstateLabelLogo(data: FormData): Promise<AxiosResponse> {
    return axiosClient.post(
      "interactive-masterplan/estate-label/upload-logo",
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
};
